module.exports = __webpack_public_path__ + "img/model_back.bf550579.png";